export enum WriterToneEnum {
  Formal = 'formal',
  Neutral = 'neutral',
  Casual = 'casual',
}
